import { render } from "./CetaMargeCampaign.vue?vue&type=template&id=4aca4102&scoped=true&ts=true"
import script from "./CetaMargeCampaign.vue?vue&type=script&lang=ts"
export * from "./CetaMargeCampaign.vue?vue&type=script&lang=ts"

import "./CetaMargeCampaign.vue?vue&type=style&index=0&id=4aca4102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aca4102"]])

export default __exports__